import { autocompleteStates } from "app/components/compare/WebsiteQueryBarTypes";

import type { IListItem } from "../../types";

export type MinimalListItemData = Pick<IListItem, "name" | "type">;

type ListItem<T> = T | autocompleteStates;

export type SupportedAutocompleteStates =
    | autocompleteStates.NO_DATA_SIMILARSITES
    | autocompleteStates.NO_DATA_SEARCHES
    | autocompleteStates.ERROR;

export const isAutocompleteState = <T,>(
    listItem: T | autocompleteStates,
): listItem is autocompleteStates => Number.isInteger(listItem);

export interface IGetListItemsGroupsParams<T> {
    listItems: Array<ListItem<T>>;
}

export const getListItemsGroups = <T extends MinimalListItemData>({
    listItems,
}: IGetListItemsGroupsParams<T>) => {
    const recents: Array<T | SupportedAutocompleteStates> = [];
    const searchResults: Array<T | SupportedAutocompleteStates> = [];
    const similar: Array<T | SupportedAutocompleteStates> = [];

    listItems.forEach((item) => {
        if (isAutocompleteState(item)) {
            switch (item) {
                case autocompleteStates.NO_DATA_SIMILARSITES:
                    similar.push(item);
                    break;
                case autocompleteStates.NO_DATA_SEARCHES:
                    searchResults.push(item);
                    break;
                case autocompleteStates.ERROR:
                    searchResults.push(item);
                    break;
            }

            return;
        }

        switch (item.type) {
            case "similar":
                similar.push(item);
                break;
            case "recent":
                recents.push(item);
                break;
            case "query":
                searchResults.push(item);
                break;
        }
    });

    return {
        recents,
        searchResults,
        similar,
    };
};
